function categoryLineAnimation() {
  const nav = document.querySelector(".nav-menu-list");
  const indicator = document.getElementById("indicator");
  const itens = nav.querySelectorAll("li.dpt-0");

  function moveIndicator(el) {
    indicator.style.left = el.offsetLeft + "px";
    indicator.style.width = el.offsetWidth + "px";
  }

  itens.forEach((item) => {
    item.addEventListener("mouseenter", () => moveIndicator(item));
  });

  nav.addEventListener("mouseleave", () => {
    indicator.style.width = "0";
  });
}

// function ButtonOffert(buttonText = "Ofertas Especiais", targetLink = "#") {
//   // Cria a div container com a classe modificada
//   const containerOffert = document.createElement("div");
//   containerOffert.className = "offertButton";

//   // Cria o link (<a>) dentro da div, com a classe modificada
//   const link = document.createElement("a");
//   link.href = targetLink;
//   link.className = "buttonOffertEspecial";

//   // Insere o SVG diretamente no link
//   link.innerHTML = `
//     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none" style="fill: red;">
//       <path d="M12.0001 5V21M12.0001 5H8.46411C8.20484 4.99989 7.94828 4.94755 7.70965 4.84619C7.47102 4.74483 7.25522 4.59667 7.07513 4.41016C6.7067 4.03329 6.50042 3.52703 6.50042 3C6.50042 2.47297 6.7067 1.96671 7.07513 1.58984C7.25522 1.40333 7.47102 1.25517 7.70965 1.15381C7.94828 1.05245 8.20484 1.00011 8.46411 1C11.2141 1 12.0001 5 12.0001 5ZM12.0001 5H15.5361C15.7954 4.99989 16.052 4.94755 16.2906 4.84619C16.5292 4.74483 16.745 4.59667 16.9251 4.41016C17.2935 4.03329 17.4998 3.52703 17.4998 3C17.4998 2.47297 17.2935 1.96671 16.9251 1.58984C16.745 1.40333 16.5292 1.25517 16.2906 1.15381C16.052 1.05245 15.7954 1.00011 15.5361 1C12.7861 1 12.0001 5 12.0001 5ZM20.0001 10V17.7998C20.0796 18.5106 20.0052 19.2306 19.7821 19.9102C19.5887 20.2842 19.2831 20.5881 18.9081 20.7798C18.2298 21.0053 17.5104 21.0806 16.8001 21H7.20013C6.48983 21.0806 5.77046 21.0053 5.0921 20.7798C4.71712 20.5881 4.41155 20.2842 4.21814 19.9102C3.995 19.2306 3.92063 18.5106 4.00012 17.7998V10M2.00012 6.6001V8.3999C1.95985 8.75367 1.99705 9.11225 2.10913 9.4502C2.20278 9.64069 2.35629 9.79518 2.54614 9.89014C2.88535 10.0028 3.24494 10.0401 3.60009 10H20.4001C20.7553 10.0401 21.1149 10.0028 21.4541 9.89014C21.6439 9.79518 21.7975 9.64069 21.8911 9.4502C22.0032 9.11225 22.0404 8.75367 22.0001 8.3999V6.6001C22.0404 6.24633 22.0032 5.88775 21.8911 5.5498C21.7975 5.35931 21.6439 5.20482 21.4541 5.10986C21.1149 4.99725 20.7553 4.95985 20.4001 5H3.60009C3.24494 4.95985 2.88535 4.99725 2.54614 5.10986C2.35629 5.20482 2.20278 5.35931 2.10913 5.5498C1.99705 5.88775 1.95985 6.24633 2.00012 6.6001Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//     </svg>
//     <span>${buttonText}</span>
//   `;

//   // Insere o link dentro do containerOffert
//   containerOffert.appendChild(link);

//   // Seleciona o elemento de referência .nav-menu-list
//   const navList = document.querySelector(".nav-menu-list");
//   if (!navList || !navList.parentNode) {
//     console.warn("Elemento .nav-menu-list não encontrado ou sem pai.");
//     return;
//   }

//   // Insere containerOffert logo após a nav-menu-list
//   navList.parentNode.insertBefore(containerOffert, navList.nextSibling);
//   setTimeout(() => {
//     const navMenu=document.querySelector(".nav-menu")
//     navMenu.style.display="flex"
//   })
// }

function addSvgOfert() {
  const svgCode = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
      <path d="M12.0001 5V21M12.0001 5H8.46411C8.20484 4.99989 7.94828 4.94755 7.70965 4.84619C7.47102 4.74483 7.25522 4.59667 7.07513 4.41016C6.7067 4.03329 6.50042 3.52703 6.50042 3C6.50042 2.47297 6.7067 1.96671 7.07513 1.58984C7.25522 1.40333 7.47102 1.25517 7.70965 1.15381C7.94828 1.05245 8.20484 1.00011 8.46411 1C11.2141 1 12.0001 5 12.0001 5ZM12.0001 5H15.5361C15.7954 4.99989 16.052 4.94755 16.2906 4.84619C16.5292 4.74483 16.745 4.59667 16.9251 4.41016C17.2935 4.03329 17.4998 3.52703 17.4998 3C17.4998 2.47297 17.2935 1.96671 16.9251 1.58984C16.745 1.40333 16.5292 1.25517 16.2906 1.15381C16.052 1.05245 15.7954 1.00011 15.5361 1C12.7861 1 12.0001 5 12.0001 5ZM20.0001 10V17.7998C20.0796 18.5106 20.0052 19.2306 19.7821 19.9102C19.5887 20.2842 19.2831 20.5881 18.9081 20.7798C18.2298 21.0053 17.5104 21.0806 16.8001 21H7.20013C6.48983 21.0806 5.77046 21.0053 5.0921 20.7798C4.71712 20.5881 4.41155 20.2842 4.21814 19.9102C3.995 19.2306 3.92063 18.5106 4.00012 17.7998V10M2.00012 6.6001V8.3999C1.95985 8.75367 1.99705 9.11225 2.10913 9.4502C2.20278 9.64069 2.35629 9.79518 2.54614 9.89014C2.88535 10.0028 3.24494 10.0401 3.60009 10H20.4001C20.7553 10.0401 21.1149 10.0028 21.4541 9.89014C21.6439 9.79518 21.7975 9.64069 21.8911 9.4502C22.0032 9.11225 22.0404 8.75367 22.0001 8.3999V6.6001C22.0404 6.24633 22.0032 5.88775 21.8911 5.5498C21.7975 5.35931 21.6439 5.20482 21.4541 5.10986C21.1149 4.99725 20.7553 4.95985 20.4001 5H3.60009C3.24494 4.95985 2.88535 4.99725 2.54614 5.10986C2.35629 5.20482 2.20278 5.35931 2.10913 5.5498C1.99705 5.88775 1.95985 6.24633 2.00012 6.6001Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  // Pega todos os containers (não só o primeiro)
  const containers = document.querySelectorAll("#departamento-185284 .nav-menu-hiperlink");

  if (!containers.length) return;

  containers.forEach(container => {
    // cria o elemento SVG a partir da string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = svgCode.trim();
    const svgElement = tempDiv.firstElementChild;

    // insere no começo do container
    container.insertBefore(svgElement, container.firstChild);
  });
}


function updateNameCategory() {
  const category = document.querySelector(
    ".nav-header #departamento-allCats-menu .nav-menu-hiperlink"
  );

  if (!category) return;

  category.innerHTML = `
    <span data-wsjs-icon="">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
        <path d="M0.727003 11.521C0.631363 11.521 0.536663 11.5021 0.448329 11.4655C0.359995 11.4288 0.279762 11.3751 0.212228 11.3074C0.144693 11.2396 0.0911846 11.1593 0.0547672 11.0708C0.0183499 10.9824 -0.000260356 10.8876 2.75128e-06 10.792V10.066C2.75128e-06 9.87319 0.0765972 9.68827 0.212936 9.55194C0.349275 9.4156 0.53419 9.339 0.727003 9.339H6.539C6.73182 9.339 6.91673 9.4156 7.05307 9.55194C7.18941 9.68827 7.266 9.87319 7.266 10.066V10.793C7.266 10.9858 7.18941 11.1707 7.05307 11.3071C6.91673 11.4434 6.73182 11.52 6.539 11.52L0.727003 11.521ZM0.727003 7.162C0.631363 7.162 0.536663 7.14313 0.448329 7.10647C0.359995 7.06981 0.279762 7.01608 0.212228 6.94836C0.144693 6.88064 0.0911846 6.80026 0.0547672 6.71183C0.0183499 6.62339 -0.000260356 6.52864 2.75128e-06 6.433V5.707C2.75128e-06 5.51419 0.0765972 5.32927 0.212936 5.19294C0.349275 5.0566 0.53419 4.98 0.727003 4.98H12.351C12.5438 4.98 12.7287 5.0566 12.8651 5.19294C13.0014 5.32927 13.078 5.51419 13.078 5.707V6.434C13.078 6.52947 13.0592 6.62401 13.0227 6.71221C12.9861 6.80042 12.9326 6.88056 12.8651 6.94807C12.7976 7.01558 12.7174 7.06913 12.6292 7.10566C12.541 7.1422 12.4465 7.161 12.351 7.161L0.727003 7.162ZM0.727003 2.803C0.631363 2.803 0.536663 2.78413 0.448329 2.74747C0.359995 2.71081 0.279762 2.65708 0.212228 2.58936C0.144693 2.52164 0.0911846 2.44126 0.0547672 2.35283C0.0183499 2.26439 -0.000260356 2.16964 2.75128e-06 2.074V1.348C2.75128e-06 1.15519 0.0765972 0.970275 0.212936 0.833936C0.349275 0.697597 0.53419 0.621002 0.727003 0.621002H12.351C12.5438 0.621002 12.7287 0.697597 12.8651 0.833936C13.0014 0.970275 13.078 1.15519 13.078 1.348V2.075C13.078 2.26781 13.0014 2.45273 12.8651 2.58907C12.7287 2.72541 12.5438 2.802 12.351 2.802L0.727003 2.803Z" fill="#4F555C"/>
      </svg>
    </span>
    Todas as categorias
    `;
}

try {
  isReady("categorias", addSvgOfert);
} catch {}

try {
  isReady("categorias", updateNameCategory);
} catch {}

// try {
//   isReady("categorias", ButtonOffert);
// } catch {}

try {
  isReady("categorias", categoryLineAnimation);
} catch {}

// fundo do mega menu
function customMegaMenu() {
  const allMegaMenu = document.querySelectorAll(
    ".nav-header .nav-menu-list > li"
  );

  if (!allMegaMenu.length) return;

  const div = document.createElement("div");
  div.classList.add("megamenu-custom-bg");

  const container = document.querySelector("header .header-bottom .container");

  container.appendChild(div);

  allMegaMenu.forEach((menu) => {
    if (!menu.querySelector(".nav-menu-main")) return;

    const mainLi = menu.parentNode.parentNode;

    if (mainLi.getAttribute("title") === "Todos os departamentos") return;

    const fatherLi = mainLi.parentNode.parentNode;

    if (
      !fatherLi ||
      !fatherLi.querySelector(".nav-menu-list > .dpt-0 > .nav-menu-hiperlink")
    )
      return;

    mainLi.querySelector(".nav-menu-megamenu-container").style.boxShadow =
      "none";

    mainLi
      .querySelector(".nav-menu-hiperlink")
      .classList.add("custom-nav-menu-hiperlink");

    mainLi.addEventListener("mouseover", (e) => {
      if (
        e.target.parentNode.classList.contains("dpt-0") &&
        !e.target.parentNode.querySelector(`.nav-menu-main`)
      )
        return;
      const megamenuCustomBg = document.querySelector(".megamenu-custom-bg");
      megamenuCustomBg.classList.add("megamenu-custom-bg-actived");
    });

    mainLi.addEventListener("mouseout", (e) => {
      const megamenuCustomBg = document.querySelector(".megamenu-custom-bg");
      megamenuCustomBg.classList.remove("megamenu-custom-bg-actived");
    });
  });
}
try {
  isReady("categorias", customMegaMenu);
} catch {}
